import { useMutation } from '@tanstack/react-query';
import { api } from '../api';
import { UserAPI } from '../../../../shared/types/api';

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: async (feedback: string) => {
      const request: UserAPI.SubmitFeedbackRequest = { feedback };
      return api.post<void>('/user/feedback', request);
    },
  });
}

